/**
 * @generated SignedSource<<f2f8769c36e1262f810dd69e31167e87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminTopicsQuery$variables = Record<PropertyKey, never>;
export type OrgAdminTopicsQuery$data = {
  readonly organisation: {
    readonly id: string;
    readonly name: string;
    readonly topics: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"OrgAdminTopicsListItem_orgTopic">;
    }> | null;
  };
};
export type OrgAdminTopicsQuery = {
  response: OrgAdminTopicsQuery$data;
  variables: OrgAdminTopicsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminTopicsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Organisation",
          "kind": "LinkedField",
          "name": "organisation",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgTopic",
              "kind": "LinkedField",
              "name": "topics",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OrgAdminTopicsListItem_orgTopic"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgAdminTopicsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefault",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ed13276e680eacf27015fce7983bdde6",
    "id": null,
    "metadata": {},
    "name": "OrgAdminTopicsQuery",
    "operationKind": "query",
    "text": "query OrgAdminTopicsQuery {\n  organisation {\n    id\n    name\n    topics {\n      id\n      name\n      ...OrgAdminTopicsListItem_orgTopic\n    }\n  }\n}\n\nfragment OrgAdminTopicsListItem_orgTopic on OrgTopic {\n  name\n  description\n  isDefault\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "f6b85de185122f015f89e057b61722aa";

export default node;
